import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { MonerisCheckoutPage } from '../../modals/moneris-checkout/moneris-checkout.page'
import { BamboraCheckoutPage } from '../../modals/bambora-checkout/bambora-checkout.page';
import { PlatformService } from 'src/app/platform.service';
import { ReceiptPage } from '../../modals/receipt/receipt.page';
import { ToastService } from 'src/app/services/toast.service';
import { DisclaimersService } from 'src/app/services/disclaimers.service';
import { utcToZonedTime,format } from 'date-fns-tz';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'app-qr-paymentform',
  templateUrl: './qr-paymentform.page.html',
  styleUrls: ['./qr-paymentform.page.scss'],
})
export class QrPaymentformPage implements OnInit {
  @Input() dailyStartDate:any
  @Input() dailyEndDate:any
  @Input() permitType:any
  userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  date = new Date();
  maxDate: any = format(utcToZonedTime(this.date, this.userTimeZone), "yyyy-MM-dd'T'HH:mm:ss'Z'", { timeZone: this.userTimeZone })
  @Input() paymentForm:FormGroup
  @Input() payType:any
  @Input() lotID:any
  @Input() cartTotal:any
  @Input() provinces:any
  @Input() vehicle?:any
  @Input() plate?:any
  @Input() hours:any
  @Input() hourlyTime:any
  @Input() hourlyDate:any
  width = window.innerWidth;
processLoading = false;
yearOptions ={
  header: 'Year',
  subHeader: 'Select expiry year',
  translucent: true,
}
monthOptions = {
  header: 'Month',
  subHeader: 'Select expiry month',
  translucent: true,
};
minDate: any = format(new Date(), 'yyyy');
expiryDates=[]
receiptID
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    public disclaimerSRV:DisclaimersService,
    private toastSRV: ToastService,
    private platformSRV:PlatformService,
    public dataService: DataService,
    private iab: InAppBrowser,
    public modalController: ModalController
  ) { }

  ngOnInit() {
    this.dailyStartDate=format(new Date(this.dailyStartDate), 'yyyy/MM/dd HH:mm:ss').toString()

    this.dailyEndDate=format(new Date(this.dailyEndDate), 'yyyy/MM/dd HH:mm:ss').toString()
    
    for(var i=0;i<15;i++){
      this.expiryDates.push(parseFloat(this.minDate)+i)
    }
  }
  closeModal(){
      // this.modalController.dismiss({receiptID:this.receiptID})
      this.processLoading=false
      this.modalController.dismiss("keep open")
  }
  
   processPayment() {
    if(this.payType?.promptFor?.toLowerCase()=='campusCard'){
      this.paymentForm.value['dateOfBirth'] = this.paymentForm.value['dateOfBirth'].replace(/-/g,'/') + ' 00:00'
    }
    this.processLoading = true;
    var data= { PayType: this.payType['PaymentTypeID'],vehicle:this.vehicle,plate:this.plate,hours:this.hours,hourlyDate:this.hourlyDate,hourlyTime:this.hourlyTime,permitType: this.permitType ,dailyStartDate:this.dailyStartDate, dailyEndDate:this.dailyEndDate };
    var items;
    if(this.payType?.gateway?.toString().toLowerCase().includes('hostpay')){
     
      items = {
      
       ...data,
       ...this.paymentForm.value,
        redirect_url: this.dataService.apiUrl + '/www/'
       
     };
    } else{
     
      items = {
      
       ...data,
       ...this.paymentForm.value
       
     };
    }
     
    this.dataService.postData(`permits/qrcode/reservation/${this.lotID}`, items).subscribe({
      next: async (res:any) => {
        //to detect if user manually closed the in app browser
        var closedAutomatically=false
      
          if (this.payType['gateway'].toString().toLowerCase().includes('hostpay') && res['packet']) {
            res['packet'] = JSON.parse(res['packet']);
          var url = new URL(res['url'])
          let getPairs = (obj, keys = []) =>
            Object.entries(obj).reduce((pairs, [key, value]) => {
              if (typeof value === 'object')
                pairs.push(...getPairs(value, [...keys, key]));
              else
                pairs.push([[...keys, key], value]);
              return pairs;
            }, []);

        let x = getPairs(res['packet'])
          .map(([[key0, ...keysRest], value]) =>
            `${key0}${keysRest.map(a => `[${a}]`).join('')}=${value}`)
          .join('&');
          url.search=x
           
           
            if(this.platformSRV.isNative.value){
              const browser = this.iab.create(url.href,'_blank',this.dataService.browserOptionsOptions)
              var connectedToUrlDetails = new URL(this.dataService.apiUrl)
              browser.on('exit').subscribe(data=>{
               if(closedAutomatically){
                this.modalController.dismiss({receiptID:res?.packet?.orderID})
               } else {
                this.modalController.dismiss("keep open")
               }
                
              })
              browser.on('loadstart').subscribe(browserResult=>{
                var urlDetails = new URL(browserResult.url)
                if(connectedToUrlDetails.hostname == urlDetails.hostname){
                  closedAutomatically=true
                  browser.close()
                 
                  
                }
                
              })
            } else {
              this.receiptID=res?.packet?.orderID
              window.location.href = url.toString();
            }
            
           
             
              
            
            
            
          } else if(this.payType['gateway'].toString() == 'MonerisCheckout'){
            const desktopModal = await this.modalController.create({
              component: MonerisCheckoutPage,
              breakpoints: [0.5, 0.8,1],
             
              cssClass: 'modal-desktop-long',
              componentProps:{
                showReceipt:false,
                res
              }
            });
            const mobileModal = await this.modalController.create({
              component: MonerisCheckoutPage,
              breakpoints: [0.5, 0.8,1],
              initialBreakpoint: 1,
              cssClass:"modal-mobile-normal",
              componentProps:{
                showReceipt:false,
                res
              }
            })
            const tabletModal = await this.modalController.create({
              component: MonerisCheckoutPage,
              breakpoints: [0.5, 0.8,1],
              initialBreakpoint: 1, 
              cssClass:"modal-tablet-normal",
              componentProps:{
                showReceipt:false,
                res
              }
            })
            var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
            modal.onDidDismiss().then(response=>{
              this.modalController.dismiss({receiptID:res['response']['unique_id']})
              
            })
            modal.present()
            
          
            
            
            
  
              
          } else if(this.payType['gateway'].toString() == 'BamboraCheckout'){
            const desktopModal = await this.modalController.create({
              component: BamboraCheckoutPage,
              breakpoints: [0.5, 0.8,1],
             
              cssClass: 'modal-desktop-long',
              componentProps:{
                res,
                from:"cart",
                showReceipt:false,
                
              }
            });
            const mobileModal = await this.modalController.create({
              component: BamboraCheckoutPage,
              breakpoints: [0.5, 0.8,1],
              initialBreakpoint: 1,
              cssClass:"modal-mobile-normal",
              componentProps:{
                res,
                from:"cart",
                showReceipt:false,
                
              }
            })
            const tabletModal = await this.modalController.create({
              component: BamboraCheckoutPage,
              breakpoints: [0.5, 0.8,1],
              initialBreakpoint: 1, 
              cssClass:"modal-tablet-normal",
              componentProps:{
                res,
                from:"cart",
                showReceipt:false,
                
              }
            })
            var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
            modal.onDidDismiss().then(response=>{
              this.modalController.dismiss({receiptID:res['response']['unique_id']})
              
            })
            modal.present()
            
            
            
          }
          
          else {
            if (res['confirm_code']) {
              this.processLoading = false;
              this.modalController.dismiss({receiptID:res['confirm_code']})
              
            }
          }
         
      },
      
      error: async (err) => {
        this.errorHandlerSRV.displayErrorMessage(err,true)
        this.modalController.dismiss("dismiss")
      }
    });
  
  }

}
